/* tslint:disable */
import React from 'react';

export const BANNER_HEIGHT = 96;

export const NAV_HEIGHT = 70;

// Using approximate height as default; will get updated on scroll
export const APPROX_HEADER_HEIGHT = BANNER_HEIGHT + NAV_HEIGHT;

export interface HeaderPropsInterface {
  bannerHeight: number;
  bottomSpace: number;
  fixNav: boolean;
  headerHeight: number;
  navHeight: number;
}

export const HEADER_PROPS: HeaderPropsInterface = {
  bannerHeight: BANNER_HEIGHT,
  bottomSpace: 0,
  fixNav: false,
  headerHeight: APPROX_HEADER_HEIGHT,
  navHeight: NAV_HEIGHT
};

const HeaderContext = React.createContext(APPROX_HEADER_HEIGHT);

export default HeaderContext;
